import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  minutes?: number;
  className?: string;
}
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function CountdownTimer({
  minutes = 17,
  className = ''
}: CountdownTimerProps) {
  const [secondsLeft, setSecondsLeft] = useState(minutes * 60);
  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const mm = Math.floor(secondsLeft / 60);
  const ss = secondsLeft % 60;
  const segment = (value: string) => <span className="bg-white/20 rounded-md px-2 py-1 tabular-nums font-mono font-bold" data-id="element-144">
      {value}
    </span>;
  return <div className={`flex items-center justify-center gap-1.5 ${className}`} data-id="element-145">
      {segment(pad(mm))}
      <span className="font-bold" data-id="element-146">:</span>
      {segment(pad(ss))}
    </div>;
}